import React from 'react';

function Thermometer({ temperature }) {
  const clampedTemp = parseInt((temperature / 75) * 100)//Math.min(Math.max(temperature, 0), 75); // Clamp temperature between 0 and 100
  // console.log("clampedTemp", clampedTemp, temperature)

  // Determine gradient color based on temperature
  const getMercuryGradient = () => {
    if (clampedTemp <= 35 || temperature === undefined) return 'linear-gradient(to top, blue, #00f2ff)';
    if (clampedTemp <= 70) return 'linear-gradient(to top, orange, #ff8000)';
    return 'linear-gradient(to top, red, #ff4d4d)';
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        {/* Temperature Labels */}
        <div
          style={{
            position: 'absolute',
            left: '-25px',
            height: '100px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            fontSize: '10px',
            color: '#333',
          }}
        >
          {Array.from({ length: 76 }, (_, index) => 75 - index) // Create the array from 75 to 0
            .filter((temp) => temp % 25 === 0) // Filter to get only multiples of 25
            .map((temp) => (
              <div key={temp} style={{alignItems:"baseline"}}>{temp}°C</div> // Display each multiple of 25
            ))}
        </div>

        {/* Thermometer container */}
        <div
          style={{
            width: '20px',
            height: '100px',
            background: '#f0f0f0',
            border: '4px solid #ccc',
            borderRadius: '20px',
            position: 'relative',
            margin: '0 auto',
            overflow: 'hidden',
          }}
        >
          {/* Mercury with gradient and animation */}
          <div
            style={{
              width: '100%',
              height: `${clampedTemp}%`,
              background: getMercuryGradient(),
              position: 'absolute',
              bottom: '0',
              borderRadius: '20px 20px 0 0',
              transition: 'height 0.5s ease, background 0.5s ease'
            }}
          ></div>
        </div>

        {/* Thermometer bulb */}
        <div
          style={{
            width: '20px',
            height: '20px',
            background: getMercuryGradient(),
            border: '4px solid #ccc',
            borderRadius: '50%',
            position: 'relative',
            margin: '-20px auto 0',
            zIndex: 1,
            transition: 'background 0.5s ease',
          }}
        ></div>
      </div>

      <p style={{ fontSize: '15px', fontWeight: 'bold', marginTop: '0px', textAlign: "center" }}>
        {temperature}°C
      </p>

      <style>
        {`
          @keyframes riseMercury {
            0% {
              height: 0;
            }
            100% {
              height: ${clampedTemp}%;
            }
          }
        `}
      </style>
    </div>
  );
}

export default Thermometer;
